












































import Vue from 'vue';

export default Vue.extend({
    name: 'Card',
    props: {
        title: {
            type: String,
            default: '',
        },

        noEditButton: Boolean,
        padding: {
            type: Boolean,
            default: true,
        },
        emptyMode: Boolean,
        emptyModeButtonText: {
            type: String,
            default: '',
        },
    },
});
